// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__WOX3V","savePackageButton":"ClientWallet_savePackageButton__zy62J"};